import { Controller } from "@hotwired/stimulus";

// Suit l'avancement d'une validation en masse.
//
// La diffusion temps reel ne suffit pas : un lot de trois transactions se
// termine en quelques dizaines de millisecondes, souvent AVANT que le
// navigateur ait fini de charger la page et de s'abonner au canal. Les
// messages partent alors dans le vide et la barre reste a zero pour
// toujours. Le sondage rattrape ce qu'on a manque, et s'arrete de lui-meme.
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 1500 },
  };

  connect() {
    if (this.finished) {
      return;
    }
    this.schedule();
  }

  disconnect() {
    this.stop();
  }

  stop() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  schedule() {
    this.timer = setTimeout(() => this.poll(), this.intervalValue);
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
      });
      if (response.ok) {
        window.Turbo.renderStreamMessage(await response.text());
      }
    } catch (error) {
      // Une coupure reseau ne doit pas tuer le suivi : on retentera.
      console.warn("Suivi du lot interrompu", error);
    }

    if (this.finished) {
      // Le lot est fini : on recharge pour que la liste perde les lignes
      // validees, sans quoi l'ecran resterait faux jusqu'au prochain clic.
      this.stop();
      window.Turbo.visit(window.location.href, { action: "replace" });
      return;
    }

    this.schedule();
  }

  get finished() {
    const panel = document.getElementById("transaction_validation_progress");
    return panel?.dataset.finished === "true";
  }
}
